<template>
  <div>
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <div class="content c-top">
      <h2>结算商品详情</h2>
      <div style="display: flex; padding-bottom: 24px">
        <div v-for="(item, index) in records" :key="index" class="record-item">
          <div class="right">
            <div class="title">{{ item.title }}</div>
            <div class="price">
              <span style="font-size: 16px">￥</span>{{ item.price }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <h3>数据筛选</h3>
      <div>
        <el-form
          :inline="true"
          :model="searchForm"
          ref="searchForm"
          class="search-form"
          size="small"
        >
          <el-form-item label="结算来源" prop="settlePlatformType">
            <el-select
              v-model="searchForm.settlePlatformType"
              placeholder="请选择结算来源"
              filterable
              clearable
            >
              <el-option label="平台" value="1"></el-option>
              <el-option label="五域" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单编号" prop="orderNo">
            <el-input
              v-model="searchForm.orderNo"
              placeholder="请输入订单编号"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态" prop="settleStatus">
            <el-select
              v-model="searchForm.settleStatus"
              placeholder="请选择状态"
              filterable
              clearable
            >
              <el-option label="待结算" value="1"></el-option>
              <el-option label="已结算" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="下单时间" prop="orderTimeStart">
            <el-date-picker
              style="width: 215px"
              v-model="value1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetchData('search')"
              >查询</el-button
            >
            <el-button type="primary" plain @click="fetchData('reset')"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <div class="title">
        <h3>列表数据</h3>
        <div>
          <!-- <el-button
            type="primary"
            icon="el-icon-upload2"
            :loading="exporting"
            @click="exportFn"
            >导出</el-button
          > -->
        </div>
      </div>
      <div id="base-list">
        <lb-table
          v-horizontal-scroll="'always'"
          :column="columns"
          :data="list"
          pagination
          :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper"
          :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="page.currentPage"
          :page-size="page.pageSize"
          @selection-change="onMultipleSelection"
          @size-change="handleSizeChange"
          @p-current-change="handleCurrentChange"
        >
        </lb-table>
      </div>
    </div>
  </div>
</template>
<script>
import breadcrumbTop from '../../../components/breadcrumb.vue'
import LbTable from '../../../components/lb-table/lb-table'
export default {
  components: {
    breadcrumbTop,
    LbTable,
  },
  data () {
    return {
      dataList: {
        list: [
          { title: '财务管理', path: '/financeManagement/platformSettlementFund', type: '0' },
          { title: '平台结算金额', path: '/financeManagement/platformSettlementFund', type: '1' },
          { title: '结算详情', path: '', type: '2' }
        ]
      },
      searchList: {
        list: [
          { title: '数据筛选', path: '', type: '0' }
        ]
      },
      records: [
        {
          title: '结算总额',
          price: '10000'
        },
        {
          title: '待结算金额',
          price: '10000'
        },
      ],
      searchTitle: {
        list: [
          { title: '结算详情', path: '', type: '0' }
        ]
      },
      list: [
        {
          name: '天兰',
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        },
        {
          image: 'https://fenxiao.muruji.com/internalSystem/3e45d792-e3d5-4823-99c9-7919ff1c7fd8'
        }
      ],
      searchForm: {
        settlePlatformType: '', // 
        orderNo: '', // 
        settleStatus: '', // 	
        orderTimeStart: '', // 	
        orderTimeEnd: '', // 	
      },
      value1: [],
      brandList: [],
      columns: [
        { type: 'selection', minWidth: '80', fixed: 'left' },
        { label: '下单时间', prop: 'orderTime', minWidth: '120' },
        { label: '结算来源', prop: 'platformName', minWidth: '220' },
        { label: '订单编号', prop: 'orderNo', minWidth: '220' },
        { label: '商品规格', prop: 'skuName', minWidth: '120' },
        { label: '数量', prop: 'quantity', minWidth: '120' },
        { label: '成本价（元）', prop: 'costPrice', minWidth: '120' },
        { label: '结算金额（元）', prop: 'settleAmount', minWidth: '120' },
        { label: '状态', prop: 'statusLabel', minWidth: '100' },
      ],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      goodsId: null,
      exporting: false
    }
  },
  created () {
    let gid = this.$route.query.goodsId;
    this.goodsId = gid;
    this.platformId = this.$route.query.platformId;
    this.getGoodsStatistics(gid)
    this.getGoodsPageList()
  },
  methods: {
    
    fetchData (type) {
      this.page.pageNo = 1;
      if (type == 'reset') {
        this.$refs['searchForm'].resetFields()
        this.searchForm.orderTimeStart = ''
        this.searchForm.orderTimeEnd = ''
        this.value1 = []
      }
      this.getGoodsPageList()
    },
    getGoodsPageList () {
      if (this.value1.length > 0) {
        this.searchForm.orderTimeStart = this.value1[0];
        this.searchForm.orderTimeEnd = this.value1[1];
      }
      this.searchForm.pageNo = this.page.pageNo;
      this.searchForm.pageSize = this.page.pageSize;
      this.searchForm.goodsId = this.goodsId;
      this.searchForm.platformId = this.platformId;
      this.axios.post('/ps/platforms/settlement/orderList', this.searchForm)
        .then(res => {
          if (res.code == 0) {
            this.list = res.data.list;
            this.page.totalNum = res.data.totalNum;
          }
        })
    },
    onMultipleSelection (e) { },
    handleSizeChange (e) {
      this.page.pageSize = e;
      this.page.pageNo = 1;
      this.getGoodsPageList()
    },
    handleCurrentChange (e) {
      this.page.pageNo = e;
      this.getGoodsPageList()
    },
    getGoodsStatistics (id) {
      this.axios.get('/ps/platforms/settlement/goods/statistics?goodsId=' + id + '&platformId='+this.platformId)
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.records[0].price = res.data.totalAmount;
            this.records[1].price = res.data.awaitAmount;
          }
        })
    },
    todetail () {
      this.$router.push({
        name: 'userDetail',
        query: {}
      })
    }
  }
}
</script>

<style scoped lang="scss">
.record-item {
  display: flex;
  width: 313px;
  width: 270px;
  height: 88px;
  background: #f2f5ff;
  opacity: 1;
  border-radius: 4px;
  margin-right: 18px;
  img {
    padding: 16px 14px;
  }
  .right {
    margin-top: 16px;
    .title {
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      line-height: 21px;
      color: #303033;
    }
    .price {
      font-size: 24px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 31px;
      color: #303033;
      margin-top: 8px;
    }
    .title {
      // width: 56px;
      height: 20px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 20px;
      color: #333333;
      opacity: 1;
      margin-left: 20px;
      // margin-top: 18px;
    }

    .price {
      // width: 103px;
      height: 25px;
      font-size: 18px;
      font-family: PingFang SC;
      font-weight: bold;
      line-height: 25px;
      color: #4168e7;
      opacity: 1;
      margin-left: 20px;
      margin-top: 8px;
    }
  }
}
.title {
  display: flex;
  justify-content: space-between;
}
#base-list {
  margin-top: 20px;
}
:deep(
    #base-list
      .lb-table
      .el-table
      .el-table__body
      .el-table__row
      .el-table__cell:last-child
      .cell
      div
  ) {
  display: inline-block;
  a {
    margin: 0 5px;
  }
}
.search-form {
  // margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  .el-form-item {
    /deep/ .el-form-item__label {
      width: 100px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }
    /deep/ .el-form-item__content {
      display: block;
      margin-left: 100px;
      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}
/deep/ .el-table{
  color:#303033
}
</style>

